import { render, staticRenderFns } from "./SiteCollectView.vue?vue&type=template&id=1d0afab2&scoped=true&"
import script from "./SiteCollectView.vue?vue&type=script&lang=js&"
export * from "./SiteCollectView.vue?vue&type=script&lang=js&"
import style0 from "./SiteCollectView.vue?vue&type=style&index=0&id=1d0afab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0afab2",
  null
  
)

export default component.exports